import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconServiceSupport = React.forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 21 21"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      className="yfm-icon yfm-icon-service-support"
      {...omit(props, ["className"])}
    >
      <path d="M10.454 2.66249C7.6014 2.66249 5.28905 4.92775 5.28905 7.72193C5.28905 10.516 7.6014 12.7813 10.454 12.7813C13.3066 12.7813 15.6189 10.516 15.6189 7.72193C15.6178 4.92775 13.3066 2.66249 10.454 2.66249ZM4.48958 9.66487V4.99321C4.4242 4.99321 4.35884 4.99548 4.29572 5.00118C5.35441 2.70256 7.71148 1.10142 10.454 1.10142C13.1965 1.10142 15.5547 2.70256 16.6122 5.00118C16.548 4.99663 16.4837 4.99321 16.4184 4.99321V9.66489C17.7351 9.66489 18.8041 8.61882 18.8041 7.32962C18.8041 6.45332 18.311 5.69058 17.5826 5.29022C16.5572 2.39865 13.7573 0.322571 10.454 0.322571C7.15064 0.322571 4.35192 2.39865 3.32533 5.2902C2.59699 5.68941 2.10379 6.4533 2.10379 7.32846C2.10379 8.6188 3.17168 9.66487 4.48958 9.66487ZM15.6075 12.3431C14.2575 13.5773 12.4463 14.3332 10.454 14.3332C8.46514 14.3332 6.65631 13.5808 5.30743 12.35C2.89411 13.5659 1.30896 15.7325 1.30896 18.6746H19.661C19.661 15.7268 18.0471 13.5578 15.6075 12.3431Z" />
    </svg>
  )
);

IconServiceSupport.displayName = "IconServiceSupport";

export default IconServiceSupport;
